export const enums = {
  mailchimp: 4,
  quickbooks: 5,
  zapier: 9,
  ecomdash: 10,
  finale: 11,
  skuVault: 12,
  edesk: 15,
  gorgias: 16,
  google: 18,
};

export const SANTOS_APP_ID = 'santos-test';
export const AMAZON_NAME = 'Amazon';

export const DISPLAY_ORDER = [
  'Webhooks',
  'Google',
  'ReturnRabbit',
  'Quickbooks Online',
  'MailChimp',
  'Zapier',
  'Gorgias',
  'Constant Contact',
  'Edesk',
  'ShipperHQ',
];
